'use client';

import { CodeBlock } from 'react-code-block';
import { Cscrollable } from '../Cscrollable';
import { pxToRem } from '@/theme/spacing';
import { getFontFamily } from '@/theme/typography';
import {
  CABAL_PRISM_THEME,
  CODE_BLOCK_FADE_SIZE,
  CODE_BLOCK_MIN_WIDTH,
  CODE_LINE_CLASS,
  CODE_LINE_NUMBER_COLOR,
  CODE_LINE_NUMBER_FONT_DELTA_PX,
  CODE_LINE_NUMBER_MIN_FONT_SIZE_PX,
  CODE_LINE_NUMBER_PADDING_RIGHT_PX,
  CODE_LINE_NUMBER_TEXT_ALIGN,
  CODE_LINE_USER_SELECT,
  CROSS_AXIS_OVERFLOW_VISIBLE,
  DEFAULT_CODE_LANGUAGE,
  SCROLL_DIRECTION_HORIZONTAL,
  SCROLL_DIRECTION_VERTICAL,
} from './cmarkdowncodeConstants';

interface CmarkdowncodeBlockProps {
  code: string;
  language: string | undefined;
  fontSizePx: number;
}

export function CmarkdowncodeBlock({ code, language, fontSizePx }: CmarkdowncodeBlockProps) {
  const resolvedLanguage = language || DEFAULT_CODE_LANGUAGE;
  const fontSize = pxToRem(fontSizePx);
  const lineNumberFontSize = pxToRem(
    Math.max(CODE_LINE_NUMBER_MIN_FONT_SIZE_PX, fontSizePx - CODE_LINE_NUMBER_FONT_DELTA_PX),
  );

  return (
    <Cscrollable
      dataElScope="Cmarkdowncode/CmarkdowncodeBlock"
      direction={SCROLL_DIRECTION_VERTICAL}
      firstItemSpacing={0}
      style={{ alignItems: 'flex-start' }}
    >
      <Cscrollable
        dataElScope="Cmarkdowncode/CmarkdowncodeBlock"
        direction={SCROLL_DIRECTION_HORIZONTAL}
        fadeSize={CODE_BLOCK_FADE_SIZE}
        crossAxisOverflow={CROSS_AXIS_OVERFLOW_VISIBLE}
        style={{ alignItems: 'flex-start' }}
      >
        <CodeBlock code={code} language={resolvedLanguage} theme={CABAL_PRISM_THEME}>
          <CodeBlock.Code
            style={{
              display: 'table',
              minWidth: CODE_BLOCK_MIN_WIDTH,
              margin: 0,
              padding: 0,
              fontFamily: getFontFamily(),
              fontSize,
              whiteSpace: 'pre',
              backgroundColor: 'transparent',
              backgroundImage: 'none',
            }}
          >
            <CodeBlock.LineContent
              className={CODE_LINE_CLASS}
              style={{ display: 'table-row' }}
            >
              <CodeBlock.LineNumber
                style={{
                  display: 'table-cell',
                  paddingRight: pxToRem(CODE_LINE_NUMBER_PADDING_RIGHT_PX),
                  userSelect: CODE_LINE_USER_SELECT,
                  color: CODE_LINE_NUMBER_COLOR,
                  textAlign: CODE_LINE_NUMBER_TEXT_ALIGN,
                  fontSize: lineNumberFontSize,
                  fontFamily: getFontFamily(),
                }}
              />
              <CodeBlock.Token />
            </CodeBlock.LineContent>
          </CodeBlock.Code>
        </CodeBlock>
      </Cscrollable>
    </Cscrollable>
  );
}
